module.exports = __webpack_public_path__ + "static/media/loading-food.c4cb9abc.gif";